import _defineProperty from "/codebuild/output/src182831320/src/scottschedule/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __rest as e } from "tslib";
import * as a from "react";
import s from "classnames";
import { ComponentClassNames as r } from "../shared/constants.js";
import { View as l } from "../View/View.js";
var i = a.forwardRef(function (i, m) {
  var t = i.children,
    o = i.className,
    n = i.visuallyHidden,
    c = e(i, ["children", "className", "visuallyHidden"]);
  return a.createElement(l, Object.assign({
    as: "label",
    className: s(r.Label, o, _defineProperty({}, r.VisuallyHidden, n)),
    ref: m
  }, c), t);
});
i.displayName = "Label";
export { i as Label };